import React, { useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { ROUTES_V2_PATHS } from 'constants/route-constants';
import {
  SCRIBE_SHOPIFY_EVENTS,
  SCRIBE_SHOPIFY_STATES,
} from 'applications/scribe/instrumentations/track';
import ShopifyTrackEventContext from '../track-event';
import { isShopConfigurationRequired } from '../common/utils';
import GearIcon from './gear-icon';
import styles from './shop-settings-button.less';

const ShopSettingsButton = ({ shopConfiguration }) => {
  const { fireShopifyTrackEvent } = useContext(ShopifyTrackEventContext);

  const onSettingsClick = useCallback(
    () => {
      fireShopifyTrackEvent({
        stateName: SCRIBE_SHOPIFY_STATES.EXPRESS_SHOPIFY_ORDERS_WEB,
        eventName: SCRIBE_SHOPIFY_EVENTS.SETTINGS,
      });
    },
    [fireShopifyTrackEvent],
  );

  const location = {
    pathname: ROUTES_V2_PATHS.shopifySettings,
    state: {
      shopConfiguration,
    },
  };

  const showIndicator = isShopConfigurationRequired(shopConfiguration);

  return (
    <Link
      to={location}
      className={styles.ShopSettingsButton}
      onClick={onSettingsClick}
    >
      <GearIcon showIndicator={showIndicator} />
      <span>Settings</span>
    </Link>
  );
};

ShopSettingsButton.propTypes = {
  shopConfiguration: PropTypes.shape({}).isRequired,
};

export default ShopSettingsButton;
